import CardWrapper from '../wrapper/card';
import DeactivateAccountModal from './modal/deactivate_account';
import { fetchUserDetailThunk } from '../../redux/thunks';
import ImageClass from '../../assets';
import { settingFlagDetails } from '../../redux/slices/index';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const UserProfileComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const { currentUser } = useSelector((state: RootState) => state.app);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                await dispatch(fetchUserDetailThunk()).unwrap();
            } catch (e) {
                //
            }
        };
        fetchUser();
    }, []);

    const onEditProfileHandler = () => {
        const data = {
            isEditing: true,
            isUpdatingPassword: false
        };
        dispatch(settingFlagDetails(data));
    };

    const onUpdatePasswordHandler = () => {
        const data = {
            isEditing: false,
            isUpdatingPassword: true
        };
        dispatch(settingFlagDetails(data));
    };

    return (
        <Box p={2}>
            <CardWrapper minHeight="85vh" overflow="auto">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h4" color="textSecondary">Profile Details</Typography>
                    <Box display="flex" gap={1}>
                        <Button variant="outlined" onClick={onEditProfileHandler} >Edit Profile</Button>
                        <Button variant="outlined" onClick={onUpdatePasswordHandler} >Update Password</Button>
                        <Button variant="outlined" color="error" onClick={() => setShowModal(true)} sx={{ display: 'none' }}>Deactivate Account</Button>
                    </Box>
                </Box>
                <Box py={2}>
                    <CardWrapper>
                        <Box display="flex" gap={2} mb={2}>
                            <Box>
                                <img
                                    src={currentUser?.profile_picture ? `${process.env.REACT_APP_FILE_PATH}${currentUser.profile_picture}` : ImageClass.userProfile}
                                    alt="User Profile"
                                    style={{
                                        borderRadius: '10px'
                                    }}
                                />
                            </Box>
                            <Box display="flex" flexDirection="column" gap={1} justifyContent="center">
                                <Typography variant="h3" fontWeight="bold" color="textSecondary">{currentUser?.name || `${currentUser?.first_name} ${currentUser?.last_name}`}</Typography>
                                <Typography variant="subtitle1" color="textSecondary">{
                                    currentUser?.role === 'organizationOwner' ? 'Organization Owner' : currentUser?.role === 'client' ? 'Customer' : currentUser?.role === 'companyManager' ? 'Company Manager' : currentUser?.role === 'organizationAdmin' ? 'Organization Admin' : currentUser?.role === 'salesManager' ? 'Sales Manager' : currentUser?.role === 'salesMember' ? 'Sales Member' : 'User'
                                }</Typography>
                            </Box>
                        </Box>
                        <Divider />
                        <Box display="flex" flexDirection="column" gap={2} my={2}>
                            <Typography variant="subtitle2" fontWeight="bold" color="textDisabled">CONTACTS</Typography>
                            <Box display="flex" justifyContent="space-between">
                                <Box><Typography variant="body2" color="textSecondary"><b>Mobile No: </b> {`+${currentUser?.phone_number}` || 'Mobile No. is empty'}</Typography></Box>
                                <Box><Typography variant="body2" color="textSecondary"><b>Email: </b> {currentUser?.email || 'Email is empty'}</Typography></Box>
                                <Box></Box>
                            </Box>
                            <Typography variant="subtitle2" fontWeight="bold" color="textDisabled">ADDRESS</Typography>
                            <Box display="flex" justifyContent="space-between">
                                <Box><Typography variant="body2" color="textSecondary"><b>State: </b> {currentUser?.state || 'State is empty'}</Typography></Box>
                                <Box><Typography variant="body2" color="textSecondary"><b>Pincode: </b> {'Pincode is empty'}</Typography></Box>
                                <Box><Typography variant="body2" color="textSecondary"><b>Country: </b> {currentUser?.country || 'Country is empty'}</Typography></Box>
                                <Box></Box>
                            </Box>
                            <Typography variant="subtitle2" fontWeight="bold" color="textDisabled">ORGANIZATION INFO</Typography>
                            <Box display="flex" justifyContent="space-between">
                                <Box><Typography variant="body2" color="textSecondary"><b>Name: </b> {currentUser?.agency_name || 'Agency name is empty'}</Typography></Box>
                            </Box>
                        </Box>
                    </CardWrapper>
                </Box>
            </CardWrapper>
            <DeactivateAccountModal open={showModal} onClose={() => setShowModal(false)} />
        </Box>
    );
};

export default UserProfileComponent;